// extracted by mini-css-extract-plugin
module.exports = {"root":"root-2VCua","details":"details-8jgRN","item":"item-2SBEh","totalRefund":"totalRefund-1KwKk"};